<template>
  <section class="job-overview m-t-lg m-b-lg">
    <h2><i class="far fa-clipboard-list"></i> Loads</h2>

    <div class="ibox">
      <div class="ibox-content">
        <ul class="list-detail list-detail-load-breakdown list-detail-load-breakdown-carrier">
          <load-item
            v-for="load in loads"
            :key="load.id"
            :load="load">
          </load-item>

          <li class="text-center text-muted" v-if="haveNoLoads">
            <strong>No loads found.</strong>
          </li>
        </ul>
      </div>
      <div class="ibox-footer">
        <router-link :to="{ name: 'loads.index' }">View All Scheduled Loads</router-link>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import LoadItem from 'components/loads/LoadItem'

  export default {
    components: {
      LoadItem
    },

    data () {
      return {
        loads: []
      }
    },

    computed: {
      haveNoLoads () {
        return this.loads.length === 0
      }
    },

    created () {
      this.getLoads({ carrier_id: this.$user.id, status: 'all', commodity: 'all', page_size: 3 })
        .then((response) => {
          this.loads = response.data.data
        })
    },

    methods: mapActions('load', ['getLoads'])
  }
</script>



// WEBPACK FOOTER //
// LoadList.vue?737562f4